import { useState, useEffect, useContext } from "react";
import * as StyleDOM from "./CandidateDocuments.jsx";
import SelectInput from "../../../../Common/Select-Input/SelectInput.js";
import Button from "../../../../Common/Button/Button.js";
import staticOptions from "../../../../Assets/Json/StaticOptions.json";
import { useFormik } from "formik";
import { Toast } from "../../../../Common/Toast-Snackbar/ToastSnackbar.js";
import {
  formatDate,
  handleCustomTrim,
  getRecruiterName
} from "../../../../Common/Common-Function/CommonFunctions.js";
import {
  post,
  get,
  put,
  patch,
  deleteRequest,
} from "../../../../helper/Api_helper.js";
import {
  VYLABS_BASE_URL,
  CREATE_CANDIDATE_TRACKING_HISTORY,
  GET_TRACKING_HISTORY_BY_CANDIDATE,
  SEARC_JOBS,
  TRACKING_APPLICATION,
  UPDATE_APPLICATION,
  APPLICATIONS_TRACKS_UPDATE,
  APPLICATIONS_TRACKS_DELETE,
  CALLBACK_REMAINDERS,
  CALLBACK_REMAINDERS_CREATE,
  CALLBACK_REMAINDERS_DELETE,
  CALLBACK_REMAINDERS_UPDATE,
  TENANTS_APPLICATION_STAGES_LIST,
  CANDIDATE_REMARKS_TRACK_LIST,
  CANDIDATE_REMARKS_TRACK_UPDATE,
  CANDIDATE_REMARKS_TRACK_DELETE,
  UPDATE_CANDIDATE_DETAILS,
} from "../../../../helper/url_helper.js";
import DynamicAutocomplete from "../../../../Common/AutoSuggestion/DynamicAutocomplete.js";
import { DynamicContext } from "../../../../Context/DynamicContext.js";
import AnimationPlayer from "../../../../Common/Animation-Player/AnimationPlayer.js";
import NoHistoryAnimation from "../../../../Assets/Json/No-History-Animation.json";
import * as Yup from "yup";
import VybogTALLoaderAnimation from "../../../../Common/Dynamic-Animations/DynamicAnimations.js";
import infoIcon from "../../../../Assets/Images/info-icon.png";
import filterInfoIcon from "../../../../Assets/Images/infoicon.svg";
import ContentDialog from "../../../../Common/Content-Dialog/ContentDialog.js";
import CustomTooltip from "../../../../Common/Tooltip/Tooltip.js";
import jobIcon from "../../../../Assets/Images/jobIcon.png";
import recruiterIcon from "../../../../Assets/Images/recruiter-icon.svg";
import recruiterDarkIcon from "../../../../Assets/Images/recruiter-icon-dark.svg";
import calenderIcon from "../../../../Assets/Images/date-icon.svg";
import calenderDarkIcon from "../../../../Assets/Images/date-icon-dark.svg";
import remarkIcon from "../../../../Assets/Images/remarks-icon.svg";
import remarkDarkIcon from "../../../../Assets/Images/remarks-icon-dark.svg";
import {
  applyEllipsis,
  toCapitalize,
} from "../../../../Common/Common-Function/CommonFunctions.js";
import TextArea from "../../../../Common/TextArea/TextArea.js";
import JobSelectionPopup from "../JobSelectionPopup";
import "../Candidates.css";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import editTrackIcon from "../../../../Assets/Images/edit-track-icon.svg";
import { ConfirmationPopup } from "../../../../Common/PopupStyles/PopupComponent.js";
import DynamicReminder from "../../../../Common/Dynamic-Reminder/DynamicReminder.jsx";
import moment from "moment";
import CallbackReminderDisplay from "../../../../Common/Callback-Reminder-UI/CallbackReminder.js";
import CandidateEmailHistory from "./CandidateEmailHistory.js";
import copyIcon from "../../../../Assets/Images/copy-icon.png";
import DynamicCallStage from "../../../../Common/DynamicCallStage/DynamicCallStage";
import { TENANT_CORE_API_KEY } from "../../../../Tenant-Config/TenantConfig.js";

function CandidateHistory({
  candidate,
  handleTabChange,
  hasSearched,
  candidateId,
}) {
  const { StaticOptions = {} } = staticOptions;
  const { callbackReminderOffset = [] } = StaticOptions || {};
  const { id = "", file_id = "" } = candidate;
  const { userDetails, isDarkMode, AdminAccess, formatDateWithUserTimezone } = useContext(DynamicContext);
  const [clearTriggered, setClearTriggered] = useState(false);
  const [trakingHistoryDataList, setTrakingHistoryDataList] = useState([]);
  const [jobFilterOptions, setJobFilterOptions] = useState([]);
  const [getCandidateID, setGetCandidateID] = useState(null);
  const [trackingLogs, setTrackingLogs] = useState([]);
  const [selectedFilterJob, setSelectedFilterJob] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [showAddTracking, setShowAddTracking] = useState(false);
  const [showUpdateDialog, setShowUpdateDialog] = useState(false);
  const [assignJobModalOpen, setAssignJobModalOpen] = useState(false);
  const [selectedJobId, setSelectedJobId] = useState(null);
  const [jobTouched, setJobTouched] = useState(false);
  const [jobError, setJobError] = useState("");
  const [jobListOptions, setJobListOptions] = useState([]);
  const [jobOptionLoading, setJobOptionLoading] = useState(false);
  const [callStage, setCallStage] = useState("");
  const [callStageTouched, setCallStageTouched] = useState(false);
  const [callStageError, setCallStageError] = useState("");
  const [addTrackCallStageTouched, setAddTrackCallStageTouched] =
    useState(false);
  const [addTrackCallStageError, setAddTrackCallStageError] = useState("");
  const [isJobSelectionOpen, setIsJobSelectionOpen] = useState(false);
  const [remark, setRemark] = useState("");
  const [isEditingLog, setIsEditingLog] = useState(false);
  const [editingLog, setEditingLog] = useState(null);
  const [editingLogIndex, setEditingLogIndex] = useState(null);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [deletingTrackId, setDeletingTrackId] = useState(null);
  const [showReminderDialog, setShowReminderDialog] = useState(false);
  const [callbackRemainderRes, setCallbackRemainderRes] = useState([]);
  const [historyViewTab, setHistoryViewTab] = useState(0);
  const [hasEmailHistory, setHasEmailHistory] = useState(false);
  const [callStages, setCallStages] = useState([]);
  const [candidatesOrJobs, setCandidatesOrJobs] = useState("Job");
  const [candidateRemarkLogs, setCandidateRemarkLogs] = useState([]);
  const [candidateRemarkLogsEdit, setCandidateRemarkLogsEdit] = useState(false);
  const [candidateRemarkLogsDelete, setCandidateRemarkLogsDelete] =
    useState(false);
  const [isCandidateRemarkLogAdd, setIsCandidateRemarkLogAdd] = useState(false);

  const handleJobInputChange = async (_, value) => {
    if (value && value.length >= 3) {
      fetchJobOptions(value);
    } else if (!value) {
      setJobListOptions([]);
    }
  };

  const handleCopyRemark = async (remarkText) => {
    if (!remarkText) return;
    try {
      await navigator.clipboard.writeText(remarkText);
      Toast("success", "Copied to clipboard");
    } catch (error) {
      console.error("Error copying remark:", error);
      Toast("error", "Failed to copy");
    }
  };

  const fetchJobOptions = async (inputValue) => {
    if (!inputValue) return;
    setJobOptionLoading(true);
    try {
      const response = await post(VYLABS_BASE_URL, SEARC_JOBS, {
        query: inputValue,
      });
      const data = response.jobs || [];
      const fetchOptions = [
        ...new Map(
          data.map((item) => [item.id, { label: item.title, value: item.id }]),
        ).values(),
      ];
      setJobListOptions(fetchOptions);
    } catch (error) {
      console.error("Error fetching jobs:", error);
    } finally {
      setJobOptionLoading(false);
    }
  };

  const handleAssignJobChange = (e) => {
    const value = e && e.target ? e.target.value : e;
    setCallStage(value);
    setCallStageTouched(true);
  };

  const handleRemarkChange = (e) => {
    setRemark(e.target.value);
  };

  useEffect(() => {
    if (callStageTouched) {
      setCallStageError(callStage ? "" : "Call Stage is required");
    }
  }, [callStage, callStageTouched]);

  const handleCallStageBlur = () => {
    setCallStageTouched(true);
    if (!callStage) {
      setCallStageError("Call Stage is required");
    } else {
      setCallStageError("");
    }
  };

  const handleJobChange = (value) => {
    setSelectedJobId(value);
    setJobTouched(true);
  };

  const handleJobBlur = () => {
    setJobTouched(true);
  };

  useEffect(() => {
    if (jobTouched) {
      setJobError(
        selectedJobId && selectedJobId.value ? "" : "Job is required",
      );
    }
  }, [selectedJobId, jobTouched]);

  const validateAssignJobForm = () => {
    let valid = true;
    if (!selectedJobId || !selectedJobId.value) {
      setJobTouched(true);
      setJobError("Job is required");
      Toast("error", "Please select a job.");
      valid = false;
    }
    if (!callStage) {
      setCallStageTouched(true);
      setCallStageError("Call Stage is required");
      Toast("error", "Please select a call stage.");
      valid = false;
    }
    return valid;
  };

  const handleAssignJobSubmit = async () => {
    if (!validateAssignJobForm()) return;

    try {
      const payload = {
        assignedRecruiterID: userDetails?.id,
        candidateID: candidate.id || candidate.candidate_id || "",
        fileID: candidate.file_id || "",
        jobId: selectedJobId.value,
        stage: callStage,
      };
      if (remark.trim()) {
        payload.remarks = remark.trim();
      }

      await post(VYLABS_BASE_URL, CREATE_CANDIDATE_TRACKING_HISTORY, payload);
      Toast("success", "Job assigned successfully");
      setAssignJobModalOpen(false);
      setRemark("");
      fetchCandidateTrackingHistory();
      try {
        const eventDetail = {
          candidateId: candidate.id || candidate.candidate_id,
          applicationId: selectedJobId?.value || null,
          updatedAt: new Date().toISOString(),
        };
        window.dispatchEvent(
          new CustomEvent("candidate-track-updated", { detail: eventDetail }),
        );
      } catch {}
    } catch (error) {
      console.error("Error adding tracking history:", error);
    }
  };

  const handleAssignJob = () => {
    setIsJobSelectionOpen(true);
    setSelectedJobId(null);
    setJobListOptions([]);
    setJobTouched(false);
    setJobError("");
    setCallStage("");
    setCallStageTouched(false);
    setCallStageError("");
    setRemark("");
  };

  const handleJobSelected = ({ job }) => {
    const newSelectedJob = { label: job.title, value: job.id };
    setSelectedJobId(newSelectedJob);
    setJobListOptions([newSelectedJob]);
    setIsJobSelectionOpen(false);
    setAssignJobModalOpen(true);
  };

  useEffect(() => {
    if (clearTriggered) {
      setClearTriggered(false);
    }
  }, [clearTriggered]);

  const fetchCandidateTrackingHistory = async () => {
    setIsLoading(true);
    const minLoaderTime = 800;
    const start = Date.now();

    try {
      const candidateIdToUse = candidateId ? candidateId : id || getCandidateID;
      let fetchResponse;
      if (candidateIdToUse) {
        fetchResponse = await get(
          VYLABS_BASE_URL,
          `${GET_TRACKING_HISTORY_BY_CANDIDATE}?candidate_id=${candidateIdToUse}`,
        );
      }
      const applications = fetchResponse?.applications || [];
      setTrakingHistoryDataList(applications);
      if (Array.isArray(applications) && applications.length > 0) {
        const sortedApplications = [...applications].sort(
          (a, b) => new Date(b.updated_at) - new Date(a.updated_at),
        );
        const uniqueJobs = [
          ...new Map(
            sortedApplications
              .filter((app) => app?.job?.title && app?.id && app?.job_id)
              .map((item) => [
                item.job_id,
                {
                  label: item.job.title || "N/A",
                  value: item.id,
                  job_id: item.job_id,
                },
              ]),
          ).values(),
        ];
        setJobFilterOptions(uniqueJobs);
        if (uniqueJobs.length > 0) {
          setSelectedFilterJob(uniqueJobs[0]);
          fetchTrackingLogs(uniqueJobs[0].value);
          fetchCallbackReminders(uniqueJobs[0].value);
        }
      } else {
        setJobFilterOptions([]);
      }
    } catch (error) {
      console.error("Error fetching tracking history:", error);
    } finally {
      const elapsed = Date.now() - start;
      const remaining = minLoaderTime - elapsed;
      if (remaining > 0) {
        setTimeout(() => setIsLoading(false), remaining);
      } else {
        setIsLoading(false);
      }
    }
  };

  const fetchTrackingLogs = async (applicationId) => {
    if (!applicationId) {
      setTrackingLogs([]);
      return;
    }
    try {
      const response = await post(VYLABS_BASE_URL, TRACKING_APPLICATION, {
        applicationID: applicationId,
        limit: 100,
        offset: 0,
      });
      setTrackingLogs(response.tracking_logs || []);
    } catch (error) {
      console.error("Error fetching tracking logs:", error);
      setTrackingLogs([]);
    }
  };

  useEffect(() => {
    if (id || getCandidateID || file_id) {
      fetchCandidateTrackingHistory();
    }
  }, [id, getCandidateID, file_id]);

  const updateTrackFormik = useFormik({
    initialValues: {
      remarks: "",
      callStage: "",
    },
    validationSchema: Yup.object({
      callStage: Yup.string().required("Call Stage is required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      if (!selectedFilterJob?.value) {
        Toast("error", "Please select a job to update");
        return;
      }
      try {
        const trimmedValues = handleCustomTrim(values);
        const isAddingNewTrack = !isEditingLog;
        const isEditingLatestTrack = isEditingLog && editingLogIndex === 0;

        let payload = {
          assignedRecruiterID: userDetails?.id,
          remarks: trimmedValues.remarks,
          stage: trimmedValues.callStage,
        };

        if (isAddingNewTrack || isEditingLatestTrack) {
          payload.id = selectedFilterJob.value;
          await put(VYLABS_BASE_URL, UPDATE_APPLICATION, payload);
        } else {
          payload.id = editingLog.id;
          await patch(VYLABS_BASE_URL, APPLICATIONS_TRACKS_UPDATE, payload);
        }
        await fetchCandidateTrackingHistory();
        await fetchTrackingLogs(selectedFilterJob.value);
        setShowAddTracking(false);
        resetForm();
        Toast("success", "Tracking updated successfully");
        try {
          const eventDetail = {
            candidateId: candidate.id || candidate.candidate_id,
            applicationId: selectedFilterJob.value,
            updatedAt: new Date().toISOString(),
          };
          window.dispatchEvent(
            new CustomEvent("candidate-track-updated", { detail: eventDetail }),
          );
        } catch {}
      } catch (error) {
        console.error("error", error);
      }
    },
  });

  const handleUpdateTrackSubmit = async (e) => {
    e.preventDefault();
    updateTrackFormik.setFieldTouched("callStage", true);
    await updateTrackFormik.validateForm();
    const trimmedValues = handleCustomTrim(updateTrackFormik.values);
    if (!trimmedValues.callStage) {
      setAddTrackCallStageTouched(true);
      Toast("error", "Please add call stage");
      return;
    }
    updateTrackFormik.handleSubmit(e);
    setShowUpdateDialog(false);
  };

  const handleJobFilterChange = (value) => {
    const selectedOption =
      jobFilterOptions.find((option) => option.value === value) || null;
    setSelectedFilterJob(selectedOption);
    fetchCallbackReminders(selectedOption?.value);
    if (selectedOption) {
      fetchTrackingLogs(selectedOption.value);
    } else {
      setTrackingLogs([]);
    }
  };

  const handleRecommendJobsClick = () => {
    if (handleTabChange) {
      handleTabChange(4);
    } else {
      console.warn("handleTabChange is not provided");
    }
  };

  const hasTrackingHistory =
    Array.isArray(trakingHistoryDataList) && trakingHistoryDataList.length > 0;
  const showJobFilter = jobFilterOptions.length > 1;
  const shouldShowHistoryHeading =
    historyViewTab === 0
      ? hasTrackingHistory && trackingLogs.length > 0
      : hasEmailHistory;

  const handleOpenAddTrack = () => {
    if (candidatesOrJobs === "Job") {
      setIsEditingLog(false);
      setEditingLog(null);
      setEditingLogIndex(null);
      setShowUpdateDialog(true);
      updateTrackFormik.resetForm();
      setAddTrackCallStageTouched(false);
      setAddTrackCallStageError("");
    }
    if (candidatesOrJobs === "Candidate") {
      candidateRemarksFormik.resetForm();
      setCandidateRemarkLogsEdit(true);
      setIsCandidateRemarkLogAdd(true);
    }
  };

  const handleEditLog = (log, index) => {
    if (candidatesOrJobs === "Job") {
      setIsEditingLog(true);
      setEditingLog(log);
      setEditingLogIndex(index);
      updateTrackFormik.setValues({
        remarks: log.new_value?.remarks || "",
        callStage: log.new_value?.stage || "",
      });
      setShowUpdateDialog(true);
    }
    if (candidatesOrJobs === "Candidate") {
      candidateRemarksFormik.setValues({
        id: log.id || "",
        remarks: log.new_value?.remarks || "",
      });
      setCandidateRemarkLogsEdit(true);
    }
  };

  const handleDeleteIconClick = (trackId) => {
    if (candidatesOrJobs === "Job") {
      setDeletingTrackId(trackId);
      setShowDeletePopup(true);
    }
    if (candidatesOrJobs === "Candidate") {
      setCandidateRemarkLogsDelete(true);
      candidateRemarksFormik.setValues({
        id: trackId,
      });
    }
  };

  const handleConfirmDelete = async () => {
    setShowDeletePopup(false);
    try {
      if (!deletingTrackId) return;
      await deleteRequest(VYLABS_BASE_URL, APPLICATIONS_TRACKS_DELETE, {
        id: deletingTrackId,
      });
      Toast("success", "Track deleted successfully");

      await fetchCandidateTrackingHistory();
      if (selectedFilterJob?.value) {
        await fetchTrackingLogs(selectedFilterJob.value);
      }
    } catch (error) {
      const backendMessage =
        error?.response?.data?.message ||
        error?.response?.data ||
        "Failed to delete track";
      Toast("error", backendMessage);
      console.error(error);
    } finally {
      setShowDeletePopup(false);
      setDeletingTrackId(null);
    }
  };

  useEffect(() => {
    if (addTrackCallStageTouched) {
      setAddTrackCallStageError(
        updateTrackFormik.values.callStage ? "" : "Call Stage is required",
      );
    }
  }, [updateTrackFormik.values.callStage, addTrackCallStageTouched]);

  const reminderFormik = useFormik({
    initialValues: {
      callbackAt: "",
      callbackTime: "",
      callbackOffset: "",
    },
    onSubmit: async (values, { resetForm }) => {
      if (
        !values.callbackAt ||
        !values.callbackTime ||
        !values.callbackOffset
      ) {
        Toast("error", "Please fill in all required fields");
        return;
      }

      try {
        const payload = {
          callbackReminderOffset: values?.callbackOffset,
          callbackReminderUserID: userDetails?.id,
          date: moment(values?.callbackAt).format("YYYY-MM-DD"),
          entityID: selectedFilterJob.value,
          entityType: "application",
          time: values?.callbackTime,
          timezone: userDetails?.timezone,
        };

        await post(VYLABS_BASE_URL, CALLBACK_REMAINDERS_CREATE, payload);
        Toast("success", "Reminder created successfully");
        fetchCallbackReminders();
        setShowReminderDialog(false);
        resetForm();
        await fetchCandidateTrackingHistory();
      } catch (error) {
        console.error("Error setting reminder:", error);
        const backendMessage =
          error?.response?.data?.message ||
          error?.response?.data ||
          "Failed to set reminder";
        Toast("error", backendMessage);
      }
    },
  });

  const editRemainderFormik = useFormik({
    initialValues: {
      callbackAt: "",
      callbackTime: "",
      callbackOffset: "",
    },
    onSubmit: async (values, { resetForm }) => {
      if (
        !values.callbackAt ||
        !values.callbackTime ||
        !values.callbackOffset
      ) {
        Toast("error", "Please fill in all required fields");
        return;
      }

      try {
        const payload = {
          callbackReminderOffset: values?.callbackOffset,
          callbackReminderUserID: userDetails?.id,
          date: moment(values?.callbackAt).format("YYYY-MM-DD"),
          entityID: selectedFilterJob.value,
          entityType: "application",
          time: values?.callbackTime,
          timezone: userDetails?.timezone,
        };

        await put(VYLABS_BASE_URL, CALLBACK_REMAINDERS_UPDATE, payload);
        Toast("success", "Reminder updated successfully");
        fetchCallbackReminders();
        setShowReminderDialog(false);
        resetForm();
        await fetchCandidateTrackingHistory();
      } catch (error) {
        console.error("Error updating reminder:", error);
        const backendMessage =
          error?.response?.data?.message ||
          error?.response?.data ||
          "Failed to update reminder";
        Toast("error", backendMessage);
      }
    },
  });

  const fetchCallbackReminders = async (applicationID) => {
    try {
      const res = await get(
        VYLABS_BASE_URL,
        `${CALLBACK_REMAINDERS}?entityType=application&entityID=${applicationID ? applicationID : selectedFilterJob?.value}`,
      );
      if (res?.callbackReminder) {
        setCallbackRemainderRes(res.callbackReminder);
      } else {
        setCallbackRemainderRes([]);
      }
    } catch (error) {
      console.error("error in fetchCallbackReminders", error);
      setCallbackRemainderRes([]);
    }
  };

  const isEditReminderMode = Boolean(callbackRemainderRes?.callbackAt);
  const activeReminderFormik = isEditReminderMode
    ? editRemainderFormik
    : reminderFormik;

  const handleOpenReminderDialog = () => {
    if (!id) {
      Toast("error", "Candidate application id is missing");
      return;
    }
    if (isEditReminderMode) {
      const callbackDateTime = new Date(callbackRemainderRes.callbackAt);
      editRemainderFormik.setValues({
        callbackAt: callbackDateTime,
        callbackTime: callbackDateTime,
        callbackOffset: callbackRemainderRes?.callbackReminderOffset || "",
      });
    } else {
      reminderFormik.resetForm();
    }
    setShowReminderDialog(true);
  };

  const handleCloseReminderDialog = () => {
    setShowReminderDialog(false);
    if (isEditReminderMode) {
      editRemainderFormik.resetForm();
    } else {
      reminderFormik.resetForm();
    }
  };

  const handleSetReminderSubmit = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (isEditReminderMode) {
      editRemainderFormik.handleSubmit(e);
    } else {
      reminderFormik.handleSubmit(e);
    }
  };

  const handleDeleteCallbackRemainder = async () => {
    try {
      await deleteRequest(VYLABS_BASE_URL, CALLBACK_REMAINDERS_DELETE, {
        entityID: selectedFilterJob.value,
        entityType: "application",
      });
      Toast("success", "Reminder deleted successfully.");
      fetchCallbackReminders();
      handleCloseReminderDialog();
    } catch (error) {
      console.error("error in handleDeleteCallbackReminder", error);
      Toast("error", error?.response?.data);
    }
  };

  const fetchCallStages = async () => {
    try {
      const response = await get(
        VYLABS_BASE_URL,
        `${TENANTS_APPLICATION_STAGES_LIST}?active=true`,
        { headers: { "X-API-Key": TENANT_CORE_API_KEY } },
      );

      const stages = Array.isArray(response)
        ? response
        : response?.stages || [];

      setCallStages(stages);
    } catch (error) {
      console.error("Error fetching call stages:", error);
      setCallStages([]);
    }
  };

  useEffect(() => {
    fetchCallStages();
  }, []);

  const callStageMap = callStages.reduce((map, stage) => {
    if (stage?.system_key) {
      map[stage.system_key] = stage.name;
    }
    return map;
  }, {});

  const candidateRemarksFormik = useFormik({
    initialValues: {
      id: "",
      remarks: "",
    },
  });

  const candidateRemarksTrackList = async () => {
    try {
      setIsLoading(true);
      const res = await post(VYLABS_BASE_URL, CANDIDATE_REMARKS_TRACK_LIST, {
        candidateID: id,
        limit: 100,
        offset: 0,
      });
      setCandidateRemarkLogs(res?.tracking_logs || []);
    } catch (error) {
      console.error("error in candidateRemarksTrackList", error);
    } finally {
      setIsLoading(false);
    }
  };

  const candidateRemarksTrackUpdate = async () => {
    try {
      const res = await patch(VYLABS_BASE_URL, CANDIDATE_REMARKS_TRACK_UPDATE, {
        id: candidateRemarksFormik.values.id,
        remarks: candidateRemarksFormik.values.remarks,
      });
      if (res.success) {
        Toast("success", "Candidate remark updated successfully");
        candidateRemarksTrackList();
        setCandidateRemarkLogsEdit(false);
        candidateRemarksFormik.resetForm();
      }
    } catch (error) {
      Toast("error", error.response?.data || "Failed to update remark.");
      console.error("error in candidateRemarksTrackUpdate", error);
    }
  };

  const candidateRemarksTrackDelete = async () => {
    try {
      const res = await deleteRequest(
        VYLABS_BASE_URL,
        CANDIDATE_REMARKS_TRACK_DELETE,
        {
          id: candidateRemarksFormik.values.id,
        },
      );
      if (res.success) {
        Toast("success", "Remark Deleted Successfully");
        candidateRemarksTrackList();
        setCandidateRemarkLogsDelete(false);
        candidateRemarksFormik.resetForm();
      }
    } catch (error) {
      Toast("error", error.response?.data || "Failed to Delete remarks");
      console.error("error in candidateRemarksTrackDelete", error);
    }
  };

  const candidateRemarksTrackAdd = async () => {
    try {
      const res = await post(VYLABS_BASE_URL, UPDATE_CANDIDATE_DETAILS, {
        id,
        remarks: candidateRemarksFormik.values.remarks,
      });
      if (res.success) {
        Toast("success", "Candidate remark updated successfully");
        candidateRemarksTrackList();
        setCandidateRemarkLogsEdit(false);
        candidateRemarksFormik.resetForm();
      }
    } catch (error) {
      Toast("error", error.response?.data || "Failed to update remark.");
      console.error("error in candidateRemarksTrackUpdate", error);
    }
  };

  const historyLogs =
    candidatesOrJobs === "Job" ? trackingLogs : candidateRemarkLogs;

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "16px",
        }}
      >
        {shouldShowHistoryHeading ? (
          <StyleDOM.TrackingHistoryHeader style={{ margin: 0 }}>
            <h3
              style={{
                color: "var(--header__color)",
                fontSize: "16px",
                fontWeight: 700,
              }}
            >
              {historyViewTab === 0
                ? `${candidatesOrJobs === "Job" ? "Job track history" : "Candidate track history"}`
                : "Email History"}
            </h3>
          </StyleDOM.TrackingHistoryHeader>
        ) : (
          <div />
        )}
        <div style={{ display: "flex" }}>
          <SelectInput
            options={[
              {
                title: "Job",
              },
              {
                title: "Candidate",
              },
            ]}
            value={candidatesOrJobs}
            onChange={(e) => {
              setHistoryViewTab(0);
              setCandidatesOrJobs(e.target.value);
              setCandidateRemarkLogs([]);
              if (e.target.value === "Candidate") candidateRemarksTrackList();
            }}
            selectStyle={{ marginRight: "10px", width: "140px" }}
            disableDefaultOption
          />
          {candidatesOrJobs === "Job" && (
            <div
              className="filter-stages"
              style={{ display: "inline-flex", whiteSpace: "nowrap" }}
            >
              <Button
                label="Track History"
                iconPosition="left"
                iconStyle={{ marginRight: "8px" }}
                event={() => setHistoryViewTab(0)}
                className={`grid-btn left ${historyViewTab === 0 ? "active" : ""}`}
              />
              <Button
                label="Email History"
                iconPosition="left"
                iconStyle={{ marginRight: "8px" }}
                event={() => setHistoryViewTab(1)}
                className={`grid-btn right ${historyViewTab === 1 ? "active" : ""}`}
              />
            </div>
          )}
        </div>
      </div>
      {historyViewTab === 1 ? (
        <CandidateEmailHistory
          candidate={candidate}
          onHasEmailHistoryChange={setHasEmailHistory}
        />
      ) : isLoading ? (
        <div className="loader-center-container">
          <VybogTALLoaderAnimation />
        </div>
      ) : (
        <>
          <StyleDOM.TrackingMainContainer>
            <StyleDOM.TrackingMainInnerContainer className="tracking-maininnercontainer">
              {(!hasTrackingHistory && candidatesOrJobs === "Job") ||
              (candidateRemarkLogs.length === 0 &&
                candidatesOrJobs === "Candidate") ? (
                <>
                  <StyleDOM.HistoryInfoText className="history-info">
                    <img
                      src={infoIcon}
                      alt="infoIcon"
                      style={{ width: "24px", height: "24px" }}
                    />
                    {candidatesOrJobs === "Job" ? (
                      <StyleDOM.HistoryInfoText className="history-info-text">
                        This candidate is not assigned to any jobs. Assign to a job to begin tracking.
                      </StyleDOM.HistoryInfoText>
                    ) : (
                      <StyleDOM.HistoryInfoText className="history-info-text">
                        This candidate does not have any remarks history. Add remarks to begin tracking.
                      </StyleDOM.HistoryInfoText>
                    )}
                  </StyleDOM.HistoryInfoText>
                  <StyleDOM.NoTrackingHistory className="no-tracking-history">
                    <AnimationPlayer
                      animationSrc={NoHistoryAnimation}
                      playerHeight="200px"
                      playerWidth="300px"
                    />
                  </StyleDOM.NoTrackingHistory>
                  {candidatesOrJobs === "Job" && (
                    <StyleDOM.HistoryButtonContainer className="history-info-button-container">
                      <Button label="Assign Job" event={handleAssignJob} />
                      {!hasSearched && (
                        <Button
                          label="Recommended Jobs"
                          event={handleRecommendJobsClick}
                        />
                      )}
                    </StyleDOM.HistoryButtonContainer>
                  )}
                  {candidatesOrJobs === "Candidate" && (
                    <StyleDOM.HistoryButtonContainer className="history-info-button-container">
                      <Button label="Add Remarks" event={handleOpenAddTrack} />
                    </StyleDOM.HistoryButtonContainer>
                  )}
                </>
              ) : (
                showJobFilter &&
                candidatesOrJobs === "Job" && (
                  <StyleDOM.TrackingUpperOuterContainer className="upperoutercontainer">
                    <div className="history-info-container">
                      <StyleDOM.TrackingHeader>
                        Select Job
                        <CustomTooltip
                          title={
                            "Tracking history will be displayed based on the job you select."
                          }
                          arrow
                        >
                          {" "}
                          <img
                            src={filterInfoIcon}
                            alt="Action 2"
                            style={{
                              width: "20px",
                              height: "20px",
                              margin: "4px 5px -4px",
                            }}
                          />
                        </CustomTooltip>
                      </StyleDOM.TrackingHeader>
                    </div>
                    <SelectInput
                      placeholder="Tracking history will be displayed based on the job you select."
                      onChange={(e) => handleJobFilterChange(e.target.value)}
                      value={selectedFilterJob?.value || ""}
                      options={jobFilterOptions}
                      labelKey="label"
                      labelValue="value"
                    />
                  </StyleDOM.TrackingUpperOuterContainer>
                )
              )}
            </StyleDOM.TrackingMainInnerContainer>
          </StyleDOM.TrackingMainContainer>

          <StyleDOM.ContentMainContainer
            className="history-contentMain-Container"
            style={{ marginTop: "-40px" }}
          >
            {historyLogs.length > 0 ? (
              <>
                {callbackRemainderRes?.callbackAt &&
                  candidatesOrJobs === "Job" && (
                    <CallbackReminderDisplay
                      reminder={callbackRemainderRes}
                      isDarkMode={isDarkMode}
                      onEdit={handleOpenReminderDialog}
                    />
                  )}
                <StyleDOM.AddTrackButtonContainer>
                  {candidatesOrJobs === "Job" ? (
                    <StyleDOM.TrackJobName className="track-job-name">
                      <img src={jobIcon} alt="jobIcon" />
                      <StyleDOM.SelectedJobTitle className="select-job-header">
                        {selectedFilterJob?.label
                          ? `${selectedFilterJob.label}`
                          : ""}
                      </StyleDOM.SelectedJobTitle>
                    </StyleDOM.TrackJobName>
                  ) : (
                    <StyleDOM.TrackJobName className="track-job-name"></StyleDOM.TrackJobName>
                  )}
                  {candidatesOrJobs === "Job" && (
                    <div
                      className="add-and-assign-job-button-container"
                      style={{ display: "flex", gap: "15px" }}
                    >
                      {!callbackRemainderRes?.callbackAt && (
                        <Button
                          label={"Set Reminder"}
                          event={handleOpenReminderDialog}
                        />
                      )}
                      <Button label="Assign New Job" event={handleAssignJob} />
                      <Button
                        label="Add Track"
                        event={handleOpenAddTrack}
                        style={{
                          whiteSpace: "nowrap",
                          minWidth: "fit-content",
                          marginLeft: "5px",
                        }}
                      />
                    </div>
                  )}
                  {candidatesOrJobs === "Candidate" && (
                    <Button
                      label="Add Remarks"
                      event={handleOpenAddTrack}
                      style={{
                        whiteSpace: "nowrap",
                        minWidth: "fit-content",
                        marginLeft: "5px",
                      }}
                    />
                  )}
                </StyleDOM.AddTrackButtonContainer>
                <StyleDOM.TrackingLowerDisplayContainer>
                  {historyLogs.map((log, index) => (
                    <StyleDOM.TrackingLowerContainer
                      className={
                        historyLogs.length > 1 ? "tracking-lowercontainer" : ""
                      }
                      key={log.id || index}
                    >
                      <StyleDOM.OuterTrackDetailsContainer
                        className="outer-track-details-container"
                        key={index}
                      >
                        {AdminAccess && (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                              gap: "10px",
                              marginBottom: "8px",
                            }}
                          >
                            <img
                              src={editTrackIcon}
                              alt="edit"
                              style={{ cursor: "pointer", width: "18px" }}
                              onClick={() => handleEditLog(log, index)}
                            />
                            {index !== 0 && (
                              <HighlightOffIcon
                                style={{
                                  cursor: "pointer",
                                  color: "red",
                                  fontSize: "20px",
                                }}
                                onClick={() => handleDeleteIconClick(log.id)}
                              />
                            )}
                          </div>
                        )}
                        <StyleDOM.CallStageDetailsContainer className="call-stage-details-container">
                          <StyleDOM.InnerTrackContents className="inner-track-contents">
                            <StyleDOM.TrackContentImage
                              src={isDarkMode ? calenderDarkIcon : calenderIcon}
                              alt="calenderIcon"
                              className="track-content-image"
                            />
                            <StyleDOM.InnerContent className="inner-content">
                              <StyleDOM.SpanHeader className="track-span-header">
                                DATE
                              </StyleDOM.SpanHeader>
                              <StyleDOM.SpanValue className="track-span-value">
                                {log.created_at
                                  ? formatDateWithUserTimezone(log.created_at)
                                  : "N/A"}
                              </StyleDOM.SpanValue>
                            </StyleDOM.InnerContent>
                          </StyleDOM.InnerTrackContents>
                          <StyleDOM.InnerTrackContents className="inner-track-contents">
                            <StyleDOM.TrackContentImage
                              src={
                                isDarkMode ? recruiterDarkIcon : recruiterIcon
                              }
                              alt="calenderIcon"
                              className="track-content-image"
                            />
                            <StyleDOM.InnerContent className="inner-content">
                              <StyleDOM.SpanHeader className="track-span-header">
                                RECRUITER
                              </StyleDOM.SpanHeader>
                              <StyleDOM.SpanValue className="track-span-value">
                                {getRecruiterName(log)}
                              </StyleDOM.SpanValue>
                            </StyleDOM.InnerContent>
                          </StyleDOM.InnerTrackContents>
                          {candidateRemarkLogs.length === 0 ? (
                            <StyleDOM.ContentStatus
                              style={{
                                backgroundColor: "var(--pagination__hover)",
                              }}
                            >
                              {toCapitalize(
                                callStageMap[log.new_value?.stage],
                              ) || toCapitalize(log.new_value?.stage)}
                            </StyleDOM.ContentStatus>
                          ) : (
                            <StyleDOM.ContentStatus></StyleDOM.ContentStatus>
                          )}
                        </StyleDOM.CallStageDetailsContainer>
                        <StyleDOM.RemarksContainer
                          className="remarks-container"
                          style={{ position: "relative" }}
                        >
                          <StyleDOM.TrackRemarkContent className="track-remark-content">
                            <img
                              src={isDarkMode ? remarkDarkIcon : remarkIcon}
                              alt="jobIcon"
                            />
                            <StyleDOM.RemarkHeaderAndValue className="remark-header-and-value">
                              <StyleDOM.RemarkHeader className="remark-header">
                                Interaction Notes
                              </StyleDOM.RemarkHeader>
                              <StyleDOM.RemarkValue className="remark-value">
                                {log.new_value?.remarks ||
                                  "No remarks available"}
                              </StyleDOM.RemarkValue>
                            </StyleDOM.RemarkHeaderAndValue>
                          </StyleDOM.TrackRemarkContent>

                          {log.new_value?.remarks && (
                            <img
                              src={copyIcon}
                              alt="copy"
                              title="Copy"
                              style={{
                                position: "absolute",
                                top: "10px",
                                right: "10px",
                                width: "18px",
                                height: "18px",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                handleCopyRemark(log.new_value.remarks)
                              }
                            />
                          )}
                        </StyleDOM.RemarksContainer>
                      </StyleDOM.OuterTrackDetailsContainer>
                    </StyleDOM.TrackingLowerContainer>
                  ))}
                </StyleDOM.TrackingLowerDisplayContainer>
              </>
            ) : (
              <>
                {showAddTracking && (
                  <StyleDOM.NoTrackingHistory className="no-tracking-history">
                    <AnimationPlayer
                      animationSrc={NoHistoryAnimation}
                      playerHeight="200px"
                      playerWidth="300px"
                    />
                  </StyleDOM.NoTrackingHistory>
                )}
              </>
            )}
          </StyleDOM.ContentMainContainer>
          <ContentDialog
            isOpen={showUpdateDialog}
            title={isEditingLog ? "Update Track" : "Add Track"}
            onClose={() => {
              setShowUpdateDialog(false);
              setAddTrackCallStageTouched(false);
              setAddTrackCallStageError("");
              updateTrackFormik.resetForm();
            }}
            onCloseIconClose={() => {
              setShowUpdateDialog(false);
              setAddTrackCallStageTouched(false);
              setAddTrackCallStageError("");
              updateTrackFormik.resetForm();
            }}
            submitButtonLabel={isEditingLog ? "Update Track" : "Add Track"}
            cancelButtonLabel="Cancel"
            event={handleUpdateTrackSubmit}
            contentHeight="auto"
            contentWidth="50vw"
          >
            <StyleDOM.TrackingUpperOuterContainer
              className="upperoutercontainer"
              style={{ padding: "20px" }}
            >
              <StyleDOM.TrackingHeader style={{ marginTop: 0 }}>
                Call Stage
              </StyleDOM.TrackingHeader>
              <DynamicCallStage
                placeholder="Call Stage"
                name="callStage"
                value={updateTrackFormik.values.callStage}
                onChange={(e) => {
                  updateTrackFormik.handleChange(e);
                  setAddTrackCallStageTouched(true);
                }}
                onBlur={(e) => {
                  updateTrackFormik.handleBlur(e);
                  setAddTrackCallStageTouched(true);
                  updateTrackFormik.setFieldTouched("callStage", true);
                  updateTrackFormik.validateField("callStage");
                }}
                error={
                  addTrackCallStageTouched && Boolean(addTrackCallStageError)
                }
                errorMessage={
                  addTrackCallStageTouched && addTrackCallStageError
                    ? addTrackCallStageError
                    : ""
                }
                menuProps={{
                  style: { zIndex: 9999 },
                }}
                selectSx={{
                  mt: "5px",
                  "& .MuiSelect-select": {
                    padding: "13px !important",
                  },
                }}
              />
              <StyleDOM.TrackingLeftContainer style={{ marginTop: "20px" }}>
                <StyleDOM.TrackingTextAreaDiv className="tracking-text-area">
                  <StyleDOM.StyledTextArea
                    name="remarks"
                    label="Remarks"
                    onChange={updateTrackFormik.handleChange}
                    onBlur={updateTrackFormik.handleBlur}
                    value={updateTrackFormik.values.remarks}
                    style={{ borderRadius: "12px" }}
                  ></StyleDOM.StyledTextArea>
                </StyleDOM.TrackingTextAreaDiv>
              </StyleDOM.TrackingLeftContainer>
            </StyleDOM.TrackingUpperOuterContainer>
          </ContentDialog>
          {candidateRemarkLogsEdit && (
            <ContentDialog
              isOpen={candidateRemarkLogsEdit}
              title={isCandidateRemarkLogAdd ? "Add Remarks" : "Update Remarks"}
              onClose={() => {
                setCandidateRemarkLogsEdit(false);
                setIsCandidateRemarkLogAdd(false);
                candidateRemarksFormik.resetForm();
              }}
              onCloseIconClose={() => {
                setCandidateRemarkLogsEdit(false);
                setIsCandidateRemarkLogAdd(false);
                candidateRemarksFormik.resetForm();
              }}
              submitButtonLabel={
                isCandidateRemarkLogAdd ? "Add Remarks" : "Update Remarks"
              }
              cancelButtonLabel="Cancel"
              event={() => {
                if (isCandidateRemarkLogAdd) {
                  candidateRemarksTrackAdd();
                } else {
                  candidateRemarksTrackUpdate();
                }
              }}
              contentHeight="auto"
              contentWidth="50vw"
            >
              <StyleDOM.TrackingUpperOuterContainer
                className="upperoutercontainer"
                style={{ padding: "20px" }}
              >
                <StyleDOM.TrackingLeftContainer style={{ marginTop: "20px" }}>
                  <StyleDOM.TrackingTextAreaDiv className="tracking-text-area">
                    <StyleDOM.StyledTextArea
                      name="remarks"
                      label="Remarks"
                      onChange={candidateRemarksFormik.handleChange}
                      onBlur={candidateRemarksFormik.handleBlur}
                      value={candidateRemarksFormik.values.remarks}
                      style={{ borderRadius: "12px" }}
                    ></StyleDOM.StyledTextArea>
                  </StyleDOM.TrackingTextAreaDiv>
                </StyleDOM.TrackingLeftContainer>
              </StyleDOM.TrackingUpperOuterContainer>
            </ContentDialog>
          )}
          <ContentDialog
            isOpen={assignJobModalOpen}
            title={
              <>
                Assign Job to{" "}
                <span
                  style={{
                    fontWeight: 1000,
                    color: "white",
                  }}
                >
                  {applyEllipsis(
                    toCapitalize(
                      candidate?.name ||
                        candidate?.BasicInfo?.Name ||
                        "Candidate",
                    ),
                    30,
                  )}
                </span>
              </>
            }
            onClose={() => {
              setAssignJobModalOpen(false);
              setRemark("");
              setSelectedJobId(null);
              setJobListOptions([]);
            }}
            onCloseIconClose={() => {
              setAssignJobModalOpen(false);
              setRemark("");
              setSelectedJobId(null);
              setJobListOptions([]);
            }}
            submitButtonLabel="Assign Job"
            cancelButtonLabel="Cancel"
            event={handleAssignJobSubmit}
            contentHeight="auto"
            contentWidth="500px"
          >
            <div
              className="assign-job-field-container"
              style={{ padding: "15px" }}
            >
              <div className="assign-job-popup-field">
                <label className="popup-label">Job</label>
                <DynamicAutocomplete
                  onChange={handleJobChange}
                  value={selectedJobId}
                  placeholder="Search Job"
                  noOptionsText="No jobs found."
                  minCharsForSearch={3}
                  onInputChange={handleJobInputChange}
                  options={jobListOptions}
                  loading={jobOptionLoading}
                  onBlur={handleJobBlur}
                  readOnly={true}
                  sx={{
                    mt: "5px",
                    ".MuiOutlinedInput-root": {
                      borderRadius: "12px",
                      height: "40px",
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "1px solid var(--border__color) !important",
                        borderRadius: "12px",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#6860ee",
                        borderRadius: "12px",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#7a70f2",
                        borderRadius: "12px",
                      },
                    },
                    ".MuiInputBase-input": {
                      color: "var(--header__color)",
                      padding: "8px 12px !important",
                      height: "40px",
                      fontFamily: "Satoshi !important",
                    },
                  }}
                  slotProps={{
                    paper: {
                      sx: {
                        backgroundColor: "var(--body__background)",
                        color: "var(--header__color)",
                        borderRadius: "12px",
                        boxShadow: "0px 4px 20px rgba(0,0,0,0.1)",
                        border: "1px solid var(--header__color)",
                      },
                    },
                    listbox: {
                      sx: {
                        "& li": {
                          fontSize: "14px",
                          fontWeight: 500,
                          padding: "8px 16px",
                          color: "var(--header__color)",
                          "&:hover": {
                            backgroundColor: "rgba(0,0,0,0.04)",
                          },
                        },
                      },
                    },
                  }}
                  error={jobTouched && Boolean(jobError)}
                  errorMessage={""}
                />
                {jobTouched && jobError && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "16px",
                      marginBottom: "6px",
                      textAlign: "left",
                    }}
                  >
                    {jobError}
                  </div>
                )}
              </div>
              <div className="assign-job-popup-field">
                <label className="popup-label">Call Stage</label>
                <DynamicCallStage
                  placeholder="Call Stage"
                  name="callStage"
                  value={callStage}
                  onChange={handleAssignJobChange}
                  onBlur={handleCallStageBlur}
                  selectStyle={{ width: "100%", height: "48px" }}
                  error={callStageTouched && Boolean(callStageError)}
                  errorMessage={
                    callStageTouched && callStageError ? callStageError : ""
                  }
                  menuProps={{
                    style: { zIndex: 9999 },
                  }}
                />
              </div>
              <div
                className="assign-job-popup-field"
                style={{ marginTop: "10px" }}
              >
                <TextArea
                  label="Remark (Optional)"
                  placeholder="Enter remark"
                  value={remark}
                  onChange={handleRemarkChange}
                  rows={3}
                  style={{
                    borderRadius: "12px",
                    border: "1px solid var(--border__color)",
                    padding: "8px 12px",
                    color: "var(--header__color)",
                    fontFamily: "Satoshi",
                    marginTop: "5px",
                  }}
                  className="popup-textarea"
                />
              </div>
            </div>
          </ContentDialog>
          <JobSelectionPopup
            isOpen={isJobSelectionOpen}
            onClose={() => setIsJobSelectionOpen(false)}
            onSelectJob={handleJobSelected}
            isDarkMode={isDarkMode}
          />
          <ConfirmationPopup
            isOpen={showDeletePopup}
            onClose={() => setShowDeletePopup(false)}
            onConfirm={handleConfirmDelete}
            title="Delete Track"
            message="Are you sure you want to delete this track?"
            confirmLabel="Yes"
            cancelLabel="No"
          />
          <ConfirmationPopup
            isOpen={candidateRemarkLogsDelete}
            onClose={() => setCandidateRemarkLogsDelete(false)}
            onConfirm={candidateRemarksTrackDelete}
            title="Delete Remark"
            message="Are you sure you want to delete this remark?"
            confirmLabel="Yes"
            cancelLabel="No"
          />
          {activeReminderFormik && (
            <DynamicReminder
              isOpen={showReminderDialog}
              onClose={handleCloseReminderDialog}
              onSubmit={handleSetReminderSubmit}
              reminderFormik={activeReminderFormik}
              callbackReminderOffset={callbackReminderOffset}
              isDarkMode={isDarkMode}
              isEditMode={isEditReminderMode}
              handleDeleteCallbackRemainder={handleDeleteCallbackRemainder}
            />
          )}
        </>
      )}
    </>
  );
}

export default CandidateHistory;